import { CalendarSource } from '../../../../constants/calendar'

export const CALENDAR_RAIL_SOURCES = [
  {
    id: CalendarSource.appointment,
    label: 'Calendar.SourceAppointmentsKey',
    qaName: 'calendarRailSourceAppointments',
    variant: 'appointment',
  },
  {
    id: CalendarSource.followUp,
    label: 'Calendar.FollowUpsKey',
    qaName: 'calendarRailSourceFollowUps',
    variant: 'followUp',
  },
  {
    id: CalendarSource.taskDeadline,
    label: 'Calendar.SourceTaskDeadlinesKey',
    qaName: 'calendarRailSourceTaskDeadlines',
    variant: 'taskDeadline',
  },
]
